import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Page_Advisor_Mini.scss';
import { AdvisorMiniPanel_Settings } from '../../mini-panels/AdvisorMiniPanel_Settings/AdvisorMiniPanel_Settings.js';
import { AdvisorConfigKeyFE_HomePanel, ModuleFE_EMInterface } from '@app/advisor-frontend';
import { AdvisorMiniPanel_Inbox } from '../../mini-panels/AdvisorMiniPanel_Inbox/AdvisorMiniPanel_Inbox.js';
import { AdvisorMiniPanel_Findings } from '../../mini-panels/AdvisorMiniPanel_Findings/AdvisorMiniPanel_Findings.js';
import { AdvisorMiniPanel_SmartDocs } from '../../mini-panels/AdvisorMiniPanel_SmartDocs/AdvisorMiniPanel_SmartDocs.js';
import { AdvisorMiniPanel_AddProtocolData } from '../../mini-panels/AdvisorMiniPanel_AddProtocolData/AdvisorMiniPanel_AddProtocolData.js';
import { debounce, exists, scrub } from '@nu-art/ts-common';
import { AdvisorMiniPanel_Spotlight } from '../../mini-panels/AdvisorMiniPanel_Spotlight/AdvisorMiniPanel_Spotlight.js';
import { AdvisorMiniPanel_Home } from '../../mini-panels/AdvisorMiniPanel_Home/AdvisorMiniPanel_Home.js';
import { ToasterPortal_Vertical } from '@nu-art/toasting';
import { ToastFilter_AdvisorGeneral } from '../toast.js';
import { AdvisorMiniPanel_ProvideInfo } from '../../mini-panels/AdvisorMiniPanel_ProvideInfo/AdvisorMiniPanel_ProvideInfo.js';
import { AdvisorMiniPanel_EventFeed } from '../../mini-panels/AdvisorMiniPanel_EventFeed/AdvisorMiniPanel_EventFeed.js';
const primaryPanelBaseHeight = 48;
const panelGap = 16;
export class Page_Advisor_Mini extends ComponentSync {
    panelScrollerRef = React.createRef();
    windowResizeDebounce = debounce(() => this.calculateAndSetMaxPanelHeight(), 50, 500);
    //######################### Life Cycle #########################
    __onWindowResized() {
        this.windowResizeDebounce();
    }
    __onReadOnlyChanged() {
        this.forceUpdate();
    }
    __onPathwayEndUpdated() {
        // if no protocol has ended ignore
        if (!ModuleFE_EMInterface.isPostDisposition())
            return;
        // update the component
        this.forceUpdate();
    }
    componentDidMount() {
        this.calculateAndSetMaxPanelHeight();
    }
    //######################### Logic #########################
    calculateAndSetMaxPanelHeight = () => {
        const panelHeights = this.calculatePanelHeights();
        if (!panelHeights)
            return;
        this.setState({ panelHeights });
    };
    calculatePanelHeights = () => {
        const container = this.panelScrollerRef.current;
        if (!container)
            return;
        return {
            primary: this.calculatePrimaryPanelHeight(container),
            secondary: this.calculateSecondaryPanelHeight(container),
        };
    };
    calculatePrimaryPanelHeight = (container) => {
        return container.clientHeight;
    };
    calculateSecondaryPanelHeight = (container) => {
        return container.clientHeight - primaryPanelBaseHeight - panelGap;
    };
    //######################### Render #########################
    render() {
        const homePanelConfig = AdvisorConfigKeyFE_HomePanel.get();
        const className = _className(ModuleFE_EMInterface.isPostDisposition() && 'post-dispo', (ModuleFE_EMInterface.isReadonly() && !ModuleFE_EMInterface.isAvatarMode()) && 'loading');
        const panelHeights = this.state.panelHeights;
        const style = scrub({
            '--primary-panel-height': exists(panelHeights?.primary) ? `${panelHeights.primary}px` : undefined,
            '--secondary-panel-height': exists(panelHeights?.secondary) ? `${panelHeights.secondary}px` : undefined,
        });
        return _jsxs(LL_V_L, { id: 'page-advisor-mini', className: className, style: style, children: [_jsxs(LL_V_L, { id: 'page-advisor-mini__panels', innerRef: this.panelScrollerRef, children: [exists(homePanelConfig) && _jsx(AdvisorMiniPanel_Home, {}), _jsx(AdvisorMiniPanel_AddProtocolData, {}), _jsx(AdvisorMiniPanel_Spotlight, {}), _jsx(AdvisorMiniPanel_Findings, {}), _jsx(AdvisorMiniPanel_Inbox, {}), _jsx(AdvisorMiniPanel_ProvideInfo, {}), _jsx(AdvisorMiniPanel_EventFeed, {}), _jsx(AdvisorMiniPanel_SmartDocs, {})] }), _jsx(AdvisorMiniPanel_Settings, {}), _jsx(ToasterPortal_Vertical, { verticalGap: 8, verticalPadding: 8, modelFilter: ToastFilter_AdvisorGeneral })] });
    }
}
//# sourceMappingURL=Page_Advisor_Mini.js.map